import React, { useState } from 'react';
import MobileBottomSheet from '../shared/MobileBottomSheet';
import ReferralContent from './ReferralContent';
import ReferralTermsContent from './ReferralTermsContent';

interface ReferralBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  referralUrl: string;
  copied: boolean;
  onCopy: () => void;
}

const ReferralBottomSheet: React.FC<ReferralBottomSheetProps> = ({
  isOpen,
  onClose,
  referralUrl,
  copied,
  onCopy,
}) => {
  const [showTerms, setShowTerms] = useState(false);

  const handleClose = () => {
    setShowTerms(false);
    onClose();
  };

  return (
    <>
      {showTerms ? (
        <div className="lg:hidden">
          <div className={`fixed inset-0 bg-white z-[60] ${isOpen ? '' : 'hidden'}`}>
            <ReferralTermsContent onBack={() => setShowTerms(false)} />
          </div>
        </div>
      ) : (
        <MobileBottomSheet
          isOpen={isOpen}
          onClose={handleClose}
          title="Invite Friends"
          maxHeight="max-h-[85vh]"
        >
          <ReferralContent
            referralUrl={referralUrl}
            copied={copied}
            onCopy={onCopy}
            onViewTerms={() => setShowTerms(true)}
            isMobile={true}
          />
        </MobileBottomSheet>
      )}
    </>
  );
};

export default ReferralBottomSheet;
